import React, { useState, useMemo, useRef, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import styles from './ReviewsCarousel.module.css';

const sampleReviews = [
  { rating: 5, text: 'This solves a HUGE problem\nFor anyone who works in Home Healthcare, the number one frustration and complaint is scheduling. This app helps the clinicians save time and be efficient so that we can focus on what matters most which is patient care', name: 'Vespa412 OT' },
  { rating: 5, text: 'Scheduling is the worst. I thought this was really helpful. It definitely saved me some time.', name: 'Kemilee K. SLP' },
  { rating: 5, text: "I've been doing Home Health in my city for over 12 years and I still struggle with the logistics. I was able to save myself 20 (!!) minutes of drive time and 16 miles on one day!!!", name: 'Rachel B. PT' },
  { rating: 5, text: 'I PRN for multiple companies and this is the only way for me to get my visits to show up in one place!', name: 'Morgan S. OT' },
  { rating: 5, text: "Hi there!... The auto group function worked brilliantly. It saved me a bunch of time compared to my personal Google Map that I have.", name: 'Riley K. COTA' },
  { rating: 5, text: "I can't wait for the android version! I'm so excited!", name: 'Amy L. OT' },
];

const Stars = ({ rating }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <span key={i} className={i <= rating ? styles.filledStar : styles.emptyStar}>★</span>
    );
  }
  return <div className={styles.stars}>{stars}</div>;
};

const ReviewsCarousel = ({ autoPlayDefault = true, interval = 4000 }) => {
  const [autoplay] = useState(autoPlayDefault);

  // refs to measure sizes
  const viewportRef = useRef(null);
  const trackRef = useRef(null);
  const [shiftPx, setShiftPx] = useState(0);

  // compute duration (seconds) based on items and interval
  const computedDuration = useMemo(() => {
    const items = sampleReviews.length;
    const baseSpeed = Math.max(1, interval / 1000); // seconds per item
    return Math.max(8, items * baseSpeed * 1.2);
  }, [interval]);

  useEffect(() => {
    const measure = () => {
      const vp = viewportRef.current;
      const tr = trackRef.current;
      if (!vp || !tr) return;
      const vpW = vp.clientWidth;
      const trW = tr.scrollWidth;
      const maxShift = Math.max(0, trW - vpW);
      setShiftPx(maxShift);
    };

    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [sampleReviews.length]);

  return (
    <div className={styles.reviewsContainer}>
      <div className={styles.viewport} ref={viewportRef}>
        <div
          ref={trackRef}
          className={`${styles.track} ${autoplay ? '' : styles.paused}`}
          style={{ ['--duration']: `${computedDuration}s`, ['--shift']: `${shiftPx}px` }}
        >
          {sampleReviews.map((r, i) => (
            <div key={i} className={styles.item}>
              <div className={styles.reviewCard}>
                <Stars rating={r.rating} />
                <div className={styles.reviewText}>&ldquo;{r.text}&rdquo;</div>
                <div className={styles.reviewer}>{r.name}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


export default ReviewsCarousel;
